import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import type { StageUpdateInDto } from 'shared/domain/workflow/types';
import type { StageUpdateRequestModel } from '../httpQueue/workflow/stageRequestRunner';

export interface EditStageUseCase {
  execute(
    stageId: string,
    stageUpdateDto: StageUpdateInDto,
    workflowId: string,
    projectId: string,
    uniqueId: string
  ): Promise<void>;
}

export class StageEditor implements EditStageUseCase {
  constructor(
    private addRequest: (request: StageUpdateRequestModel) => Promise<unknown>
  ) {}

  async execute(
    stageId: string,
    stageUpdateDto: StageUpdateInDto,
    workflowId: string,
    projectId: string,
    uniqueId: string
  ): Promise<void> {
    debugLog('StageEditor.execute', stageId, stageUpdateDto);
    const request: StageUpdateRequestModel = {
      createdAt: Date.now(),
      method: 'PUT',
      url: `/project/${projectId}/workflow/${workflowId}/stage/${stageId}`,
      data: {
        stageUpdateDto,
        stageId,
        workflowId,
        projectId,
        uniqueId,
      },
      entityType: HttpRequestModelType.workflowStage,
      status: HttpRequestStatus.NEW,
    };

    await this.addRequest(request);
  }
}

export const stageEditor = new StageEditor(addRequest);
